import * as zod from 'zod';

export const recuperarSenhaValidationSchema = zod.object({
  email: zod
    .string({ required_error: 'Campo obrigatório' })
    .min(1, 'Informe o e-mail')
    .email('E-mail inválido'),
});

export type RecuperarSenhaFormData = zod.infer<typeof recuperarSenhaValidationSchema>;
